var _style, _defs, _defs2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScenarioModellingSliderWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000182512678889425707520000008979097781969074849_);}\n\t.st1{clip-path:url(#SVGID_00000163776300566049421390000000385109361400013485_);}\n\t.st2{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 90,
    height: 90
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000175320912669691791740000016468850891022996883_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000175320912669691791740000016468850891022996883_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000103229737104177450650000011113975921957994164_",
    width: 89.8,
    height: 90
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121960006964759545280000001444941588624810929_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103229737104177450650000011113975921957994164_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000121960006964759545280000001444941588624810929_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.8,81.5V9.8C89.8,7,85.7,0,78.1,0c-1.5,0-3.1,0.3-4.7,0.8c-0.4,0.1-0.7,0.5-0.7,1v12.9H1 c-0.6,0-1,0.5-1,1V89c0,0.6,0.5,1,1,1h80.3C86,90,89.8,86.2,89.8,81.5z M74.8,2.6c1.1-0.3,2.3-0.5,3.3-0.5 c6.5,0,9.6,6.2,9.6,7.7v65c-2.4-2.6-5.7-3.9-9.3-3.9c-1.2,0-2.4,0.1-3.7,0.4V2.6z M2.1,16.8h70.7v55.9c0,0.3,0.2,0.6,0.4,0.8 c0.3,0.2,0.6,0.2,0.9,0.2c1.4-0.5,2.9-0.7,4.4-0.7c4.3,0,7.4,2,9.3,5.3v3.2c0,3.6-2.9,6.4-6.4,6.4H2.1V16.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.5,22.3h41.2c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1H6.5c-0.6,0-1,0.5-1,1C5.5,21.8,6,22.3,6.5,22.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.5,26.8h35c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1h-35c-0.6,0-1,0.5-1,1C5.5,26.3,6,26.8,6.5,26.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.5,31.3h28.9c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1H6.5c-0.6,0-1,0.5-1,1C5.5,30.8,6,31.3,6.5,31.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.3,53.4H38.4v-8.1l2.4,2.4c0.4,0.4,1.1,0.4,1.5,0c0.4-0.4,0.4-1.1,0-1.5l-4.1-4.1 c-0.4-0.4-1.1-0.4-1.5,0l-4.1,4.1c-0.4,0.4-0.4,1.1,0,1.5c0.4,0.4,1.1,0.4,1.5,0l2.4-2.4v8.1H6.5c-0.6,0-1,0.5-1,1v29 c0,0.6,0.5,1,1,1h61.8c0.6,0,1-0.5,1-1v-29C69.3,53.9,68.9,53.4,68.3,53.4z M51.3,55.6h16v6.6h-16V55.6z M49.2,55.5v7.7 c0,0.6,0.5,1,1,1h17v5.4H41.5c-0.6,0-1,0.5-1,1v11.7H25.6v-7.6c0-0.6-0.5-1-1-1h-17v-7.6h29.8c0.6,0,1-0.5,1-1v-9.7L49.2,55.5 L49.2,55.5z M36.4,55.5v8.7H7.6v-8.7H36.4z M7.6,82.4v-6.6h16v6.6H7.6z M67.3,82.4H42.6V71.7h24.7V82.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47,78.1h5.3c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1H47c-0.6,0-1,0.5-1,1C46,77.6,46.4,78.1,47,78.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.5,78.1h5.3c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1h-5.3c-0.6,0-1,0.5-1,1C56.5,77.6,57,78.1,57.5,78.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.2,28.4h6.2c0.6,0,1-0.5,1-1v-6.2c0-0.6-0.5-1-1-1h-6.2c-0.6,0-1,0.5-1,1v6.2 C52.2,28,52.6,28.4,53.2,28.4z M54.2,22.3h4.1v4.1h-4.1V22.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.5,20.2h-6.2c-0.6,0-1,0.5-1,1v6.2c0,0.6,0.5,1,1,1h6.2c0.6,0,1-0.5,1-1v-6.2 C70.5,20.7,70,20.2,69.5,20.2z M68.5,26.4h-4.1v-4.1h4.1V26.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.2,38.8h6.2c0.6,0,1-0.5,1-1v-6.2c0-0.6-0.5-1-1-1h-6.2c-0.6,0-1,0.5-1,1v6.2 C52.2,38.3,52.6,38.8,53.2,38.8z M54.2,32.6h4.1v4.1h-4.1V32.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.5,30.6h-6.2c-0.6,0-1,0.5-1,1v6.2c0,0.6,0.5,1,1,1h6.2c0.6,0,1-0.5,1-1v-6.2C70.5,31,70,30.6,69.5,30.6 z M68.5,36.7h-4.1v-4.1h4.1V36.7z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenarioModellingSliderWhite);
export default __webpack_public_path__ + "static/media/scenario-modelling-slider-white.21b6f69e693d0cbad20e11ecddb94afb.svg";
export { ForwardRef as ReactComponent };